import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../context/ModalContext';
import { TableRefreshContext } from '../../context/TableRefreshContext';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import {
  IDispatcherUserRequest,
  IDispatcherUserResponse,
} from '../../models/user/dispatcherUser.model';
import useHttps from '../useHttps';

const useDispatcherUser = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [resetInputFields, setResetInputFields] = useState(false);
  const modalContext = useContext(ModalContext);
  const refreshTableContext = useContext(TableRefreshContext);

  const oncreateDispatcherUserError = (err: AxiosError<ErrorHttpResponse>) => {
    modalContext?.displayModal(true);
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while creating clearer'
    );
  };

  const oncreateDispatcherUserSuccess = ({
    message,
  }: SuccessHttpResponse<IDispatcherUserResponse>) => {
    setResetInputFields(true);
    modalContext?.displayModal(false);
    refreshTableContext?.setRefreshTable(!refreshTableContext?.refreshTable);
    toast.success(message);
  };

  const createDispatcherUser = (data: IDispatcherUserRequest) => {
    const url: HttpConfig = {
      url: 'authentication-service/v1/dispatchers',
      method: 'post',
      data,
    };

    request(
      url,
      oncreateDispatcherUserSuccess,
      setLoading,
      oncreateDispatcherUserError
    );
  };

  return { createDispatcherUser, loading, resetInputFields };
};

export default useDispatcherUser;
